import { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import AnimatedSelect from "../../../shared/AnimatedSelect";
import "../../../shared/AnimatedSelect.css";

const PartnerCategoryFilters = ({ filterValues = {}, partnerCategories = [], onFilterChange }) => {
  // Initialize as array for multiselect
  const getInitialValue = () => {
    if (filterValues.partnerCategory != null) {
      return Array.isArray(filterValues.partnerCategory) 
        ? filterValues.partnerCategory 
        : [filterValues.partnerCategory];
    }
    return [];
  };
  
  const [selectedCategory, setSelectedCategory] = useState(getInitialValue());

  // Keep local UI state in sync when parent provides prefilled values
  useEffect(() => {
    if (filterValues.partnerCategory != null) {
      const categoryIds = Array.isArray(filterValues.partnerCategory) 
        ? filterValues.partnerCategory.map(String)
        : [String(filterValues.partnerCategory)];
      const allCategoryIds = partnerCategories.map(item => String(item.id));
      
      // Check if all categories are selected - if so, include "All" in the state
      const allSelected = allCategoryIds.length > 0 && 
        allCategoryIds.every(id => categoryIds.includes(id));
      
      if (allSelected && allCategoryIds.length > 0) {
        setSelectedCategory(["All", ...allCategoryIds]);
      } else {
        setSelectedCategory(categoryIds);
      }
    } else {
      setSelectedCategory([]);
    }
  }, [filterValues.partnerCategory, partnerCategories]);

  return (
    <>
      <Col className="custom_col">
        <AnimatedSelect
          value={filterValues.hasDone || "Include"}
          options={[
            { label: "Include", value: "Include" },
            { label: "Exclude", value: "Exclude" }
          ]}
          onChange={(value) => onFilterChange && onFilterChange("hasDone", value)}
        />
      </Col>
      <Col className="custom_col">
        <AnimatedSelect
          multiple={true}
          maxDisplayItems={5}
          value={selectedCategory}
          options={[
            { label: "All Partners", value: "All" },
            ...partnerCategories.map((item) => ({
              label: item.name,
              value: item.id
            }))
          ]}
          onChange={(value) => {
            const currentValue = Array.isArray(value) ? value.map(String) : [];
            const allCategoryIds = partnerCategories.map(item => String(item.id));
            const wasAllSelected = Array.isArray(selectedCategory) && selectedCategory.map(String).includes("All");
            const isAllSelected = currentValue.includes("All");
            
            // Get currently selected category IDs (excluding "All")
            const selectedIds = currentValue.filter(v => v !== "All");
            
            // Check if all categories are currently selected
            const allCategoriesSelected = allCategoryIds.length > 0 && 
              allCategoryIds.every(id => selectedIds.includes(id));
            
            if (isAllSelected && !wasAllSelected) {
              // "All Partners" was just checked - select all categories and keep "All" checked
              const allValues = ["All", ...allCategoryIds];
              // Ensure "All" is always first and included
              setSelectedCategory(allValues);
              // Send only category IDs to payload, exclude "All"
              onFilterChange && onFilterChange("partnerCategory", allCategoryIds);
              return; // Early return to prevent further processing
            } else if (!isAllSelected && wasAllSelected) {
              // "All Partners" was just unchecked - uncheck all categories
              setSelectedCategory([]);
              onFilterChange && onFilterChange("partnerCategory", []);
              return; // Early return to prevent further processing
            } else {
              // Individual categories are being selected/deselected
              if (allCategoriesSelected) {
                // All categories selected - automatically check "All Partners"
                const newValue = ["All", ...allCategoryIds];
                setSelectedCategory(newValue);
                // Send only category IDs to payload, exclude "All"
                onFilterChange && onFilterChange("partnerCategory", allCategoryIds);
              } else {
                // Not all categories selected - ensure "All Partners" is unchecked and update with current selection
                setSelectedCategory(selectedIds);
                // Send only category IDs to payload, exclude "All"
                onFilterChange && onFilterChange("partnerCategory", selectedIds);
              }
            }
          }}
        />
      </Col>      
    </>
  );
};

export default PartnerCategoryFilters;

